import { render, staticRenderFns } from "./NewParticipantToList.vue?vue&type=template&id=1ce13bfe&"
import script from "./NewParticipantToList.vue?vue&type=script&lang=js&"
export * from "./NewParticipantToList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports